import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAmparoPorTramiteFondo } from '../../services/amparoService';

const formatearFecha = (iso) => {
    if (!iso) return '';
    const [y, m, d] = String(iso).split('T')[0].split('-');
    return `${d}/${m}/${y}`;
};

/**
 * Chip "Amparo iniciado" para la ficha de un trámite PREVISIONAL (RTI, Jubilación, Pensión, PNC,
 * Reajuste): avisa que sobre ese expediente se promovió un amparo por mora y linkea a su ficha.
 *
 * Es el dato que el Excel anota a mano sobre la fila del trámite de fondo ("AMPARO INICIADO",
 * "AMPARO: 12/11/2024") en las planillas ARCHIVO/LISTA.
 *
 * No renderiza nada si el trámite no tiene amparo (el backend responde 204): es una ausencia
 * esperada y el caso mayoritario, así que no ocupa lugar ni muestra un cartel vacío.
 */
export default function ChipAmparoIniciado({ idTramite }) {
    const navigate = useNavigate();
    const [amparo, setAmparo] = useState(null);

    useEffect(() => {
        if (!idTramite) {
            setAmparo(null);
            return;
        }
        let activo = true;
        getAmparoPorTramiteFondo(idTramite)
            .then((data) => { if (activo) setAmparo(data); })
            .catch((err) => {
                // Silencioso a propósito: es un aviso accesorio, no tiene que romper la ficha.
                console.error('No se pudo consultar el amparo del trámite:', err);
                if (activo) setAmparo(null);
            });
        return () => { activo = false; };
    }, [idTramite]);

    if (!amparo) {
        return null;
    }

    // La fecha que le interesa al estudio es la del pronto despacho (el primer reclamo formal). Si
    // todavía no se cargó, se muestra el estado a secas.
    const fecha = formatearFecha(amparo.fechaProntoDespacho || amparo.fechaAmparoPresentado);

    return (
        <button
            type="button"
            className="badge rounded-pill px-3 py-2 border-0 d-inline-flex align-items-center gap-1"
            style={{ backgroundColor: '#ffe4e6', color: '#9f1239', border: '1px solid #fecdd3', cursor: 'pointer' }}
            title={`Ver el amparo por mora (${amparo.nombreEstadoActual || 'sin estado'})`}
            onClick={() => navigate(`/amparo/tramites/${amparo.idTramite}`)}
        >
            <i className="bi bi-shield-exclamation"></i>
            Amparo iniciado{fecha ? ` ${fecha}` : ''}
            <span className="text-muted small ms-1">· {amparo.nombreEstadoActual || '—'}</span>
        </button>
    );
}
